'use client'
import { createContext, useContext } from 'react'

export type Locale = 'en' | 'fa' | 'ar'

export const LangContext = createContext<Locale>('fa')

export function useLang() {
  return useContext(LangContext)
}
